import * as React from 'react';
import { TDocument } from '../../utils';
import MGCForm from './MGC/index';
import { MGADLForm } from 'Routes/MyService/Document/Form/SurveyForms/MGADL';
import { IMGADL } from 'neuro-schemas';
import { useIntl } from 'react-intl';

const FunctionalPerformanceForm = ({ formData, document, viewing = false }: IOwnProps): React.JSX.Element | null => {
  const { _type } = document ?? {};

  const { locale } = useIntl();

  switch (_type) {
    case 'mgc':
      return <MGCForm formData={formData as IFormData<IMGC>} viewing={viewing} />;
    case 'mgadl':
      return (
        <MGADLForm
          formData={formData as IFormData<IMGADL>}
          editing={!viewing}
          viewing={viewing}
          locale={locale}
          clinicalForm={true}
        />
      );
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<TDocument>;
  document?: TDocument;
  viewing?: boolean;
}

export default FunctionalPerformanceForm;
